module.exports = __webpack_public_path__ + "img/pablo_micas.6fd876b5.png";